import React, { memo, useMemo } from 'react';

import { Badge } from 'antd';

import { useAppSelector } from '../../../shared/hooks';
import { UAMPermissions } from '../../../types/userTypes';
import CreatorTag from './CreatorTag';

type Props = {
  user: {
    _id: string;
    name: string;
    profilePicUrl: string;
    profilePicType: string;
    reaction?: string;
    onboarding?: string;
  };
  isOnline?: boolean;
  isClickable: boolean;
  onClick: () => void;
  isOnlyReaction?: boolean;
  handleRemoveReaction?: () => void;
};

const CommunityUserCard: React.FC<Props> = ({
  user,
  isClickable,
  onClick,
  isOnline,
  isOnlyReaction = false,
  handleRemoveReaction,
}) => {
  const { hostMetadata } = useAppSelector((state) => state?.app);
  const userDetails = useAppSelector((state) => state?.user);

  const isCreatorOrUAM = useMemo(() => {
    return (
      userDetails?.id === user?._id ||
      userDetails?.id === hostMetadata?.creator?._id ||
      userDetails?.userAccessPermissions?.includes(
        UAMPermissions?.COMMUNITY_ACCESS,
      )
    );
  }, [
    userDetails?.id,
    userDetails?.userAccessPermissions,
    user?._id,
    hostMetadata?.creator?._id,
  ]);

  return (
    <div className="user-card" key={user?._id}>
      <div
        className={`user-card_user-wrapper`}
        style={{ position: 'relative' }}
        onClick={isClickable ? onClick : () => {}}>
        <div className={`user-card_user-wrapper_avatar`}>
          {user?.profilePicType === 'image' ? (
            <div className="user-card_user-wrapper_avatar_img-wrapper">
              <img src={user?.profilePicUrl} alt="" />
            </div>
          ) : (
            <div className="user-card_user-wrapper_avatar_emoji">
              {user?.profilePicUrl}
            </div>
          )}
          {isOnline ? (
            <Badge status="success" size="default" offset={[-10, 25]} />
          ) : null}
          <div className="user-card_user-wrapper_avatar_text-wrapper">
            <h4>{user?.name}</h4>
            {hostMetadata?.creator?._id === user?._id ? <CreatorTag /> : null}
          </div>
          {(userDetails?.id === user?._id ||
            (isCreatorOrUAM && user?._id === hostMetadata?.creator?._id)) &&
          isOnlyReaction ? (
            <button
              className="user-card_user-wrapper_avatar_remove-button"
              onClick={() => {
                if (handleRemoveReaction) {
                  handleRemoveReaction();
                }
              }}>
              Tap to remove
            </button>
          ) : null}
        </div>
      </div>
      {user?.reaction ? <div>{user?.reaction}</div> : null}
    </div>
  );
};

export default memo(CommunityUserCard);
